(function () {
  var mql = window.matchMedia('(min-width: 750px)');
  if (!mql.matches) return;

  var gallery = document.querySelector('media-gallery[data-desktop-layout="thumbnail_slider"]');
  if (!gallery) return;

  var thumbSlider = gallery.querySelector('[id^="GalleryThumbnails"]');
  if (!thumbSlider || !thumbSlider.slider) return;

  // Patch: use vertical dimensions for page calculation
  thumbSlider.initPages = function () {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(function (el) {
      return el.clientHeight > 0;
    });
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;
    if (this.sliderItemOffset === 0) return;
    this.slidesPerPage = Math.floor(
      (this.slider.clientHeight - this.sliderItemsToShow[0].offsetTop) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  };

  // Patch: vertical visibility check
  thumbSlider.isSlideVisible = function (element, offset) {
    if (offset === undefined) offset = 0;
    var lastVisible = this.slider.clientHeight + this.slider.scrollTop - offset;
    return (
      element.offsetTop + element.clientHeight <= lastVisible &&
      element.offsetTop >= this.slider.scrollTop
    );
  };

  // Patch: vertical scroll position
  thumbSlider.setSlidePosition = function (position) {
    this.slider.scrollTo({ top: position, behavior: 'smooth' });
  };

  // Patch: vertical page tracking
  thumbSlider.update = function () {
    if (!this.slider || !this.sliderItemOffset) return;
    this.currentPage = Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1;
    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollTop === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }
    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  };

  // Patch: media-gallery setActiveThumbnail for vertical scroll
  gallery.setActiveThumbnail = function (thumbnail) {
    if (!this.elements.thumbnails || !thumbnail) return;
    this.elements.thumbnails.querySelectorAll('button').forEach(function (el) {
      el.removeAttribute('aria-current');
    });
    thumbnail.querySelector('button').setAttribute('aria-current', 'true');
    if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
    this.elements.thumbnails.slider.scrollTo({
      top: thumbnail.offsetTop,
      behavior: 'smooth',
    });
  };

  // Re-initialize with vertical logic
  thumbSlider.initPages();
})();
